//@config
export default {
  jobsProfile:{
    getJobsProfile: 'v1/jobs-profile'
  }
};
